import styled from "styled-components";
import {DesignedButton} from '../../FaqPage/CustomizedProduction/DesignedButton/DesignedButton'

export const DialogH1 = styled.h1`
font-weight : 600;
text-align : center;
padding : 40px 0 0px 0;
color : black;
`
export const Dialogp = styled.div`
/* background : #eeeeee; */
font-size : 16px;
padding : 20px 5rem 0 5rem;
/* color : $color-black; */
font-weight : 500;
text-align : center;
white-space : pre-line;
@media screen and (max-width : 440px) {
    padding : 1rem 1.5rem;
} 
`

export const DesignedButtonD = styled(DesignedButton)`
margin: 10px auto !important;
border : 4px solid black;
`